<template>
    <div id="home" class="bg-main">
        <Top />
        <About />
    </div>
</template>

<script>
  import Top from '../components/Top'
  import About from '@/views/About'

  export default {
    name: 'Home',
      components: {
        Top, About
      }
  }
</script>
